import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Home } from 'lucide-react';
import api from '../../axios'; // Adjust the import path as necessary
export default function PaymentResultPages() {
  const [searchParams] = useSearchParams();
  const reference = searchParams.get('reference');
  const [transaction, setTransaction] = useState(null);
  const [status, setStatus] = useState('loading');
  

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const res = await api.get(`/transactions/${reference}`);
        setTransaction(res.data.transaction);
        setStatus('success');
        console.log(res.data.transaction);
      } catch (err) {
        setStatus('failure');
      }
    };

    if (reference) fetchTransaction();
  }, [reference]);

  if (status === 'loading') return <p className="text-center mt-10">Loading payment details...</p>;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      {status === 'success' ? (
        <SuccessPage transaction={transaction} />
      ) : (
        <FailurePage />
      )}
    </div>
  );
}

function SuccessPage({ transaction }) {
    const navigate = useNavigate();
  return (
    <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="p-8">
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 rounded-full p-3">
            <CheckCircle className="w-16 h-16 text-green-500" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">Payment Successful!</h1>
        <p className="text-center text-gray-600 mb-6">
          Your transaction has been completed successfully.
        </p>
        
        <div className="bg-gray-50 p-4 rounded-lg mb-6">
          <div className="flex justify-between mb-2">
            <span className="text-gray-500">Transaction ID</span>
            <span className="font-medium">{transaction.reference}</span>
          </div>
          <div className="flex justify-between mb-2">
            <span className="text-gray-500">Amount</span>
            <span className="font-medium">₦{transaction.amount.toLocaleString()}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-500">Date</span>
            <span className="font-medium">{new Date(transaction.paid_at).toLocaleString()}</span>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4">

          <button
           onClick={() =>{
            navigate('/customer');
          } 

          }
          
          className="py-3 px-6 bg-green-600 hover:bg-green-700 text-white rounded-lg transition duration-200 font-medium flex items-center justify-center">
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </button>
          {/* <button className="py-3 px-6 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-lg transition duration-200 font-medium flex items-center justify-center">
            View Receipt
          </button> */}
        </div>
      </div>
      
      <div className="bg-green-50 p-4 text-center">
        <p className="text-green-600 text-sm">Payment Details have been sent to your mail</p>
      </div>
    </div>
  );
}

function FailurePage() {
    const navigate = useNavigate();
  return (
    <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="p-8">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 rounded-full p-3">
            <XCircle className="w-16 h-16 text-red-500" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">Payment Failed</h1>
        <p className="text-center text-gray-600 mb-6">
          We couldn't process your payment. Please try again.
        </p>
        
        <div className="bg-red-50 p-4 rounded-lg mb-6">
          <div className="flex items-start">
            <XCircle className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
            <p className="text-red-700 text-sm">
              There was an issue with your payment method. Please check your card details or try a different payment method.
            </p>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4">
          
          <button 
            onClick={() =>{
                navigate('/customer');
            } 

            }
          className="py-3 px-6 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-lg transition duration-200 font-medium flex items-center justify-center">
            <Home className="w-4 h-4 mr-2" />
            Back to Home
          </button>
        </div>
      </div>
      
      <div className="bg-gray-50 p-4">
        <p className="text-gray-500 text-sm text-center">
          Need help? <a href="#" className="text-red-600 hover:text-red-700">Contact our support team</a>
        </p>
      </div>
    </div>
  );
}
